import { render, staticRenderFns } from "./OrderDetailPaymentType.vue?vue&type=template&id=941a8d14&scoped=true&"
import script from "./OrderDetailPaymentType.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPaymentType.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPaymentType.vue?vue&type=style&index=0&id=941a8d14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941a8d14",
  null
  
)

export default component.exports